import { useQuery, UseQueryOptions } from "react-query";
import { IMetabaseDashboard, Route } from "@edgetier/watchtower-types";
import { AxiosError } from "axios";
import { getAllPaginatedItems } from "utilities/get-all-paginated-items";

/**
 * Request the metabase dashboards from the backend.
 * @param url             The URL used to make the request.
 * @param queryParameters Any query parameters to send with the request.
 * @returns An array of metabase dashboards.
 */
const requestMetabaseDashboards = async (url: string, queryParameters: {}) => {
    const data = await getAllPaginatedItems<IMetabaseDashboard>(url, { params: queryParameters });
    return data;
};

/**
 * A query to get the metabase dashboards that the user can view.
 * @param queryParameters Any query parameters to send with the request.
 * @param options         Any react query options to send with the query.
 */
const useMetabaseDashboards = <T = IMetabaseDashboard[]>(
    queryParameters: {} = {},
    options: Omit<UseQueryOptions<IMetabaseDashboard[], AxiosError, T>, "queryKey" | "queryFn"> = {}
) => {
    const url = Route.MetabaseDashboards;
    return useQuery<IMetabaseDashboard[], AxiosError, T>(
        [url, queryParameters],
        () => requestMetabaseDashboards(url, queryParameters),
        options
    );
};

export default useMetabaseDashboards;
